import { ElementsSDK } from '@yiluhub/ui-sdk-react';
import React from 'react';

interface CardLinkProps {
  linkUrl: string;
  dataTestId?: string;
  focused?: boolean;
  setFocus: (focused: boolean) => void;
  handleClick?: (event: React.MouseEvent | React.KeyboardEvent) => void;
  children: React.ReactNode;
}

const CardLink: React.FC<CardLinkProps> = ({
  linkUrl,
  dataTestId,
  handleClick,
  children,
  focused,
  setFocus,
}) => {
  return (
    <ElementsSDK.Link
      data-testid={dataTestId}
      href={linkUrl}
      target="_blank"
      rel="noreferrer"
      tabIndex={0}
      onClick={() => {
        if (handleClick) {
          handleClick({} as React.MouseEvent);
        }
      }}
      onFocus={() => setFocus(true)}
      onBlur={() => setFocus(false)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' && focused) {
          handleClick && handleClick(e);
        }
      }}
    >
      {children}
    </ElementsSDK.Link>
  );
};

export default CardLink;
